import { Fragment } from "react";

export const RoomDetails = (props) => {
  const { branding, bookingDetails } = props;
  return (
    <Fragment>
      <h3
        className="mt-4"
        style={{
          color: branding.headingColor,
          fontFamily: branding.headingFont,
        }}
      >
        Room Details
      </h3>
      {bookingDetails.rooms.map((room, index) => {
        console.log(room); // Debugging log to check the `room` object
        return (
          <div
            key={index}
            className="mt-3"
            style={{
              border: "1px solid #ddd",
              borderRadius: "8px",
              overflow: "hidden",
              backgroundColor: "#f8f8f8",
            }}
          >
            <div
              style={{
                backgroundColor: "#6c757d",
                color: "#fff",
                padding: "10px",
                fontSize: "16px",
                fontWeight: "bold",
              }}
            >
              Room {index + 1}: {room.room}
            </div>
            <table className="table">
              <tbody>
                <tr>
                  <th>Number of Rooms</th>
                  <td>{room.numberOfRooms}</td>
                </tr>
                <tr>
                  <th>Rate Plan</th>
                  <td>{room.ratePlanName}</td>
                </tr>
                <tr>
                  <th>Rate</th>
                  <td>{room.ratePlanRate.toLocaleString()} VND</td>
                </tr>
                <tr>
                  <th>Adults</th>
                  <td>{room.adults}</td>
                </tr>
                <tr>
                  <th>Children</th>
                  <td>{room.children}</td>
                </tr>
                <tr>
                  <th>Extra Bed</th>
                  <td>
                    {Object.values(room.extraBed || {}).some(
                      (value) => value === true
                    )
                      ? `Yes`
                      : "No"}
                  </td>
                </tr>
                <tr>
                  <th>Cancellation Policy</th>
                  <td>{room.cancellationPolicy || "Flexible"}</td>
                </tr>
              </tbody>
            </table>
          </div>
        );
      })}
    </Fragment>
  );
};
